const StyledDropdown = () => {
  $(document).ready(function () {
    $('select.custom-styled-dropdown').niceSelect();
    $('select.custom-styled-multioption').niceSelect();
  })
}
export default StyledDropdown;